// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"22":"ef360de7","118":"ccc4585e","327":"1600b950","358":"64b85cb3","431":"40c038ec","473":"fe78643f","518":"4835e8d6","761":"43560d15","765":"ec426765","779":"25993aed"}[chunkId] + ".js";
};